import styled from 'styled-components/macro';
import { DESKTOP, MOBILE_LANDSCAPE, TABLET_LANDSCAPE, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';

export const GalleryThumbnailGrid = styled.ul`
  column-gap: 15px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  margin: 20px 0;
  padding: 0;
  position: relative;
  row-gap: 20px;
  width: 100%;

  @media ${MOBILE_LANDSCAPE} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media ${TABLET_PORTRAIT} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    row-gap: 25px;
  }

  @media ${TABLET_LANDSCAPE} {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  @media ${DESKTOP} {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;

export const GalleryThumbnailGridItem = styled.li`
  list-style: none;
  overflow: hidden;
  padding: 0;
`;
